import { API_PREFIX } from '@/constants';
import axios from 'axios';

export const upload = ({ number, file, auth }) => {
  const { corpId } = auth;
  const formData = new FormData();
  formData.append('picture', file);
  return axios.request({
    url: `${API_PREFIX.CUSTOMER}/user/task/${corpId}/invalid/${number}`,
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data',
      'X-Requested-With': 'XMLHttpRequest'
    },
    withCredentials: true,
    data: formData
  });
}
